<template>
  <!--
  <div>
    <div class="mb-24">
      <UiHeroTop :article="blogStore.filterArticlesByTag(blog, 'Excluded')[0]" />
    </div>
    
    <div class="mt-8 mb-32">
      <ContentNewsSection
        :articles="filteredArticles"
        :tag="null"
        :small="false"
        :openedHandle="openedHandle"
      />
    </div>
  </div>
  -->
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()

if (process.server) {
  defineNuxtRouteMiddleware(() => {
    return navigateTo('/blogs/journal', { redirectCode: 302 }) // Temporary redirect
  })
} else {
  router.replace('/blogs/journal')
  throw new Error('Redirecting to /blogs/journal')
}



/* TEMPORARY REDIRECT TO JOURNAL PAGE 
import { useBlogStore } from '@/stores/blogStore';
import { usePageStore } from '@/stores/pageStore';
import { computed, ref, watch, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useNewsSeo } from '../../composables/seo';


const blogStore = useBlogStore();
const pageStore = usePageStore();
const route = useRoute();
const router = useRouter();
const { getSeoPageMeta } = useImageUtils();
const openedHandle = ref(route.query.article || null); // Get article handle from query

// Fetch the blog data before rendering the page
const { data: blog } = await useAsyncData('blog', async () => {  
  return await blogStore.fetchBlogByHandle('news');
});

// Filter articles to exclude those tagged with "Excluded"
const filteredArticles = computed(() => {
  return blog.value?.articles.filter(article => 
    !(article.tags && article.tags.includes('Excluded'))
  ) || [];
});

// Watch for changes in route query and update openedHandle
watch(() => route.query.article, (newHandle) => {
  openedHandle.value = newHandle;
});

// Ensure article opens when arriving via deep link
onMounted(() => {
  if (route.query.article) {
    openedHandle.value = route.query.article;
  }
});

const { data: newspage, error } = await useAsyncData('newspage', () =>
  pageStore.fetchPageByHandle('news')
)
useNewsSeo()
*/
</script>
